

import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useQueryClient, useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  NumberInput,
  NumberInputField,
  Image,
  Stack,
  useToast,
  VStack,
  FormErrorMessage,
  Spinner,
  Text,
} from '@chakra-ui/react';
import { getItemById, createItem, updateItem } from '../../../api/item';
import { PostDataWithImg,UpdateDataWithImg } from '../../../api/apiFactory';

const schema = yup.object().shape({
  name: yup.string().required('Name is required'),
  description: yup.string().required('Description is required'),
  startPrice: yup.number().required('Start Price is required').min(0),
  commission1: yup.number().required('commission1 is required').min(0),
  commission2: yup.number().required('commission2 is required').min(0),
  commission3: yup.number().required('commission3 is required').min(0),

  minBidIncrement: yup.number().required('Min Bid Increment is required').min(0),

  coverphoto: yup.mixed().required('Cover photo is required'),
  thubnailphoto: yup.mixed().required('Thumbnail photos are required'),
});

const AddItemForm = ({ isOpen, onClose, itemId = null, subcategoryId }) => {
  const { register, handleSubmit, setValue, formState: { errors }, watch, reset } = useForm({
    resolver: yupResolver(schema)
  });
  const toast = useToast();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const [coverPhoto, setCoverPhoto] = useState(null);
  const [thumbnailPhotos, setThumbnailPhotos] = useState([]);

  const { data, isLoading, error } = useQuery(['item', itemId], () => getItemById(itemId), {
    enabled: !!itemId,
    
    onSuccess: (data) => {
      const item = data.data.data;
      
      setValue('name', item.name);
      setValue('description', item.description);
      setValue('startPrice', parseInt(item.mainlystartPrice));
      setValue('commission1', parseInt(item.commission1));
      setValue('commission2', parseInt(item.commission2));
      setValue('commission3', parseInt(item.commission3));


      setValue('minBidIncrement', parseInt(item.minBidIncrement));
      setCoverPhoto(item.coverphoto ? [item.coverphoto] : null);
      setThumbnailPhotos(item.thubnailphoto ? item.thubnailphoto : []);
    },
    onError: (error) => {
      toast({
        title: 'Error',
        description: error.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  });

  const mutation = useMutation(itemId ? (data) => updateItem(itemId, data) : (data) => createItem(data), {
    onSuccess: () => {
      queryClient.invalidateQueries('items');
      toast({
        title: itemId ? 'Lots updated.' : 'Lots added.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      onClose();
      window.location.reload();
    },
    onError: (error) => {
      toast({
        title: 'Error',
        description: error.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  });

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('startPrice', data.startPrice);
    formData.append('mainlystartPrice', data.startPrice);
    formData.append('minBidIncrement', data.minBidIncrement);

    formData.append('commission1', data.commission1);
    formData.append('commission2', data.commission2);
    formData.append('commission3', data.commission3);


    formData.append('subcategoryId', subcategoryId);


    console.log(data.coverphoto)
    if (data.coverphoto&&data.coverphoto[0]) {
      formData.append('coverphoto', data.coverphoto[0]);
    }
console.log(data.thubnailphoto)
    // if (data.thubnailphoto&&data.thubnailphoto[0]) {

    //   for (const key of Object.keys(data.thubnailphoto)) {
    //     formData.append('thubnailphoto', data.thubnailphoto[key]);
    //   }
    // }
    if (data.thubnailphoto && Object.keys(data.thubnailphoto).length > 0) {
      for (const key of Object.keys(data.thubnailphoto)) {
        formData.append('thubnailphoto', data.thubnailphoto[key]);
      }
    }
    mutation.mutate(formData);
  };

  const handleFileChange = (e, setFieldValue) => {
    const files = e.target.files;
    setFieldValue(files);
  };

  const renderImagePreview = (file) => {
    if (file instanceof File || file instanceof Blob) {
      return <Image src={URL.createObjectURL(file)} alt="Preview" />;
    }
    return null;
  };

  if (isLoading) {
    return <Spinner />;
  }

  if (error) {
    return <Text>Error: {error.message}</Text>;
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{itemId ? 'Update Lots' : 'Add Lots'}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <form id="item-form" onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={4}>
              <FormControl isInvalid={errors.name}>
                <FormLabel htmlFor="name">Name</FormLabel>
                <Input id="name" placeholder="Name" {...register('name')} />
                <FormErrorMessage>{errors.name?.message}</FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={errors.description}>
                <FormLabel htmlFor="description">Description</FormLabel>
                <Textarea id="description" placeholder="Description" {...register('description')} />
                <FormErrorMessage>{errors.description?.message}</FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={errors.startPrice}>
                <FormLabel htmlFor="startPrice">Start Price</FormLabel>
                <NumberInput>
                  <NumberInputField id="startPrice" placeholder="Start Price" {...register('startPrice', { valueAsNumber: true })} />
                </NumberInput>
                <FormErrorMessage>{errors.startPrice?.message}</FormErrorMessage>
              </FormControl>
              
              <FormControl isInvalid={errors.commission1}>
                <FormLabel htmlFor="commission1">1 commission % </FormLabel>
                <NumberInput>
                  <NumberInputField id="commission1" placeholder="comisson " {...register('commission1', { valueAsNumber: true })} />
                </NumberInput>
                <FormErrorMessage>{errors.commission1?.message}</FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={errors.commission2}>
                <FormLabel htmlFor="commission2">2 commission % </FormLabel>
                <NumberInput>
                  <NumberInputField id="commission2" placeholder="comisson " {...register('commission2', { valueAsNumber: true })} />
                </NumberInput>
                <FormErrorMessage>{errors.commission2?.message}</FormErrorMessage>
              </FormControl>    <FormControl isInvalid={errors.commission3}>
                <FormLabel htmlFor="commission3">3 commission %</FormLabel>
                <NumberInput>
                  <NumberInputField id="commission3" placeholder="comisson " {...register('commission3', { valueAsNumber: true })} />
                </NumberInput>
                <FormErrorMessage>{errors.commission3?.message}</FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={errors.minBidIncrement}>
                <FormLabel htmlFor="minBidIncrement">Min Bid Increment</FormLabel>
                <NumberInput>
                  <NumberInputField id="minBidIncrement" placeholder="Min Bid Increment" {...register('minBidIncrement', { valueAsNumber: true })} />
                </NumberInput>
                <FormErrorMessage>{errors.minBidIncrement?.message}</FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={errors.coverphoto}>
                <FormLabel htmlFor="coverphoto">Cover Photo</FormLabel>
                <Input type="file" id="coverphoto" {...register('coverphoto')} onChange={(e) => handleFileChange(e, setCoverPhoto)} />
                {coverPhoto && renderImagePreview(coverPhoto[0])}
                <FormErrorMessage>{errors.coverphoto?.message}</FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={errors.thubnailphoto}>
                <FormLabel htmlFor="thubnailphoto">Thumbnail Photos</FormLabel>
                <Input  type="file" id="thubnailphoto" {...register('thubnailphoto')} multiple onChange={(e) => handleFileChange(e, setThumbnailPhotos)} />
                {thumbnailPhotos && Array.from(thumbnailPhotos).map((photo, index) => (
                  <div key={index}>
                    {renderImagePreview(photo)}
                  </div>
                ))}
                <FormErrorMessage>{errors.thubnailphoto?.message}</FormErrorMessage>
              </FormControl>
            </Stack>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} isLoading={mutation.isLoading} type="submit" form="item-form">
            {itemId ? 'Update' : 'Add'}
          </Button>
          <Button variant="ghost" onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddItemForm;
